import React from 'react';
import {Helmet} from 'react-helmet-async';
import AuthPageWithEmail from 'app/routes/AuthPageWithEmail';

const SignUpWithEmailPage = () => {
  const props = {
    type: 'signup',
    headline: 'Konto erstellen',
    subtitle: 'Werde Teil der Community',
    backToOptionsText: 'Alle Registrierungsoptionen',
    backToOptionsLink: '/auth/signup',
  };
  const meta = [
    {name: 'description', content: 'Erstelle jetzt kostenlos dein FuPa-Konto und präsentiere deinen Verein.'},
  ];
  return (
    <>
      <Helmet title='Registrieren' meta={meta}>
        <link rel='canonical' href='https://www.fupa.net/auth/login' />
      </Helmet>
      <AuthPageWithEmail {...props} />
    </>
  );
};

export default SignUpWithEmailPage;
